export default class AitiCoreValidatorPhoneNumber {

    private _phoneNumberCache: object = {};

    isValid(number: string, defaultCountry?: string): boolean {
        return !!(this._getPhoneNumber(number, defaultCountry) && this._getPhoneNumber(number, defaultCountry).isValid());
    }

    isPossible(number: string, defaultCountry?: string): boolean {
        return !!(this._getPhoneNumber(number, defaultCountry) && this._getPhoneNumber(number, defaultCountry).isPossible());
    }

    getCountryCode(number: string, defaultCountry?: string): string | null {
        return this._getPhoneNumber(number, defaultCountry) ? (this._getPhoneNumber(number, defaultCountry).country || null) : null;
    }

    getCountryCallingCode(number: string, defaultCountry?: string): string | null {
        return this._getPhoneNumber(number, defaultCountry) ? (this._getPhoneNumber(number, defaultCountry).countryCallingCode || null) : null;
    }

    getNationalNumber(number: string, defaultCountry?: string): string {
        return this._getPhoneNumber(number, defaultCountry) ? (this._getPhoneNumber(number, defaultCountry).nationalNumber || null) : number;
    }

    getInternationalNumber(number: string, defaultCountry?: string, format: boolean = false): string {
        format = format || false;
        return this.format(number, defaultCountry, format ? 'INTERNATIONAL' : 'E.164');
    }

    format(number: string, defaultCountry?: string, format: string = 'E.164'): string {
        format = format || 'E.164';
        return (this._getPhoneNumber(number, defaultCountry) ? this._getPhoneNumber(number, defaultCountry).format(format) : number);
    }

    getInternationalNumber00(number: string, defaultCountry?: string): string {
        return this.getInternationalNumber(number, defaultCountry).replace(/^\+/, '00');
    }

    private _getPhoneNumber(number: string, defaultCountry?: string): any | null {
        if (typeof window.libphonenumber === 'undefined') {
            throw new Error('libphonenumber-js library is not loaded');
        }

        if (typeof this._phoneNumberCache[number + ';' + defaultCountry] === 'undefined') {
            let phoneNumber = window.libphonenumber.parsePhoneNumberFromString(number, defaultCountry) || null;

            if (phoneNumber === null) {
                if (number.substr(0, 2) === '00') {
                    number = '+' + number.substr(2);
                    phoneNumber = window.libphonenumber.parsePhoneNumberFromString(number, defaultCountry) || null;
                }
            }

            this._phoneNumberCache[number + ';' + defaultCountry] = phoneNumber;
        }

        return this._phoneNumberCache[number + ';' + defaultCountry];
    }
}

declare global {
    interface Window {
        libphonenumber: any;
    }
}
